var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLion = function SvgLion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.948 10.708c-.738 8.854-9.592 12.543-11.068 12.543S1.55 19.562.812 10.708C.077 1.884 5.977-1.1 11.88 1.853c5.903-2.953 11.803.031 11.068 8.855"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.258 9.97c0-2.853-1.982-5.165-4.427-5.165a4.07 4.07 0 0 0-2.951 1.34 4.07 4.07 0 0 0-2.951-1.34C6.484 4.805 4.5 7.117 4.5 9.97c0 2.667 1.464 4.89 3.689 5.165-.624.318-.738 1.475-.738 2.213 0 1.476 2.213 2.952 4.427.738 2.214 2.214 4.427.738 4.427-.738 0-.738-.114-1.895-.738-2.213 2.227-.274 3.691-2.498 3.691-5.165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.356 13.659c0 .407-.66.738-1.476.738-.815 0-1.476-.331-1.476-.738m1.476.738v3.689"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M8.56 9.975a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m6.64.75a.375.375 0 1 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
  })));
};
export default SvgLion;